import { RefObject, useEffect, useState } from 'react';

/**
 * True while a sideways row has more content past its right edge. The tab row then fades out at
 * the right (design navigation-v2 b 2a), so the reader sees that it scrolls. Without
 * ResizeObserver (old browsers, jsdom) it only follows the scroll position.
 */
export function useOverflowFade(ref: RefObject<HTMLElement | null>): boolean {
  const [fadeEnd, setFadeEnd] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (element === null) {
      return undefined;
    }
    const measure = () => {
      setFadeEnd(element.scrollLeft + element.clientWidth < element.scrollWidth - 1);
    };
    measure();
    element.addEventListener('scroll', measure, { passive: true });
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(element);
    return () => {
      element.removeEventListener('scroll', measure);
      observer?.disconnect();
    };
  }, [ref]);

  return fadeEnd;
}
